import firebase from "firebase/app";
import "firebase/auth";

class Firebase {
  constructor() {
    const config = {
      apiKey: "AIzaSyBgrsliKtkys8JeJEcgUEBNF_dPes1zT4I",
      authDomain: "syncman-205613.firebaseapp.com",
      databaseURL: "https://syncman-205613.firebaseio.com",
      projectId: "syncman-205613",
      storageBucket: "",
      messagingSenderId: "117112045036"
    };

    this.client = firebase.initializeApp(config);
  }

  signIn = async () => {
    let provider = new firebase.auth.GoogleAuthProvider();
    provider.addScope(
      "https://www.googleapis.com/auth/userinfo.profile" +
        " https://www.googleapis.com/auth/userinfo.email"
    );
    try {
      const result = await this.client.auth().signInWithPopup(provider);
      return result.user;
    } catch (err) {
      console.error(err);
    }
  };

  signOut = async () => {
    await this.client.auth().signOut();
  };
}

export default new Firebase();



// WEBPACK FOOTER //
// ./src/lib/firebase.js